module.exports = __webpack_public_path__ + "img/标题icon_14.7cc8932b.png";